import ObjectSelectorForm from 'scoreboard/components/object-selector-form'
import FormView from 'scoreboard/components/form-view'
import i18n from 'scoreboard/components/i18n'
import highlight from 'scoreboard/components/highlight'

/**
 * For choosing a scorecard item to swap nodes for a strategy map
 * Perspectives and objectives may only be replaced with the same item type
 */
const StrategyMapObjectSelectorForm = ObjectSelectorForm.extend({
	initialize: function (options) {
		this.FormView = FormView.extend({
			test: this.test.bind(this)
		})
		ObjectSelectorForm.prototype.initialize.call(this, options)
	},

	test: function () {
		let selected = this.objectSelector.selected()
		if (selected) {
			// if a different type was selected for a perspective or objective
			if ((this.options.type === 'perspective' || this.options.type === 'objective') &&
				selected.type !== this.options.type) {
				let key = 'dashboards.swap.invalid.' + this.options.type
				return i18n.get(key, highlight(selected.label))
			} else {
				return null
			}
		} else {
			return i18n.get('common.select.required')
		}
	}

})

export default StrategyMapObjectSelectorForm

StrategyMapObjectSelectorForm.__filename__ = 'dashboards/edit/strategy-map-object-selector-form.js'
